import { createSlice } from "@reduxjs/toolkit";
import { DEProcess } from "../models/lmf.models";

const DataEntryReducerInitialState: {
  isDataLoading: boolean;
  isSubmitLoading: boolean;
  errorMessage: string;
  notificationMessage: string;
  deProcess: DEProcess | null;
  lastUpdate: Date;
} = {
  errorMessage: "",
  notificationMessage: "",
  isDataLoading: false,
  isSubmitLoading: false,
  deProcess: null,
  lastUpdate: new Date(),
};

export const DataEntryReducer = createSlice({
  name: "__",
  initialState: DataEntryReducerInitialState,
  reducers: {
    setIsDataLoading(state, { payload }) {
      state.isDataLoading = payload;
    },
    setIsSubmitLoading(state, { payload }) {
      state.isSubmitLoading = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setNotificationMessage(state, { payload }) {
      state.notificationMessage = payload;
    },
    setDEProcess(state, { payload }) {
      state.deProcess = payload;
    },
    setProcess(state, { payload }) {
      if (state.deProcess) {
        state.deProcess.process = payload;
      }
    },
    setLastUpdate(state) {
      state.lastUpdate = new Date();
    },
  },
});
